module.exports = __webpack_public_path__ + "img/banner_m.be99bbda.png";